import type SessionType from '@/contexts/Session/SessionType';

export function createDefaultSession(): SessionType {
  return {
    jwt: '',
    userInfo: {},
    sessionExtraData: {},
    tmp_member_id: undefined,
    member_id: undefined,
    legal_document_acceptances: [],
    me: undefined,
    session_id: null,
  };
}

const defaultSession = createDefaultSession();

export default defaultSession;
